import * as React from "react";
import {
  useColorMode,
  useColorModeValue,
  IconButton,
  IconButtonProps,
} from "@chakra-ui/react";
import { FiMoon, FiSun } from "react-icons/fi";

type ColorModeSwitcherProps = Omit<IconButtonProps, "aria-label">;

export const ColorModeSwitcher: React.FC<ColorModeSwitcherProps> = props => {
  const { toggleColorMode } = useColorMode();
  const text = useColorModeValue("dark", "light");
  const SwitchIcon = useColorModeValue(FiMoon, FiSun);

  return (
    <IconButton
      size="sm"
      fontSize="md"
      variant="ghost"
      borderRadius="full"
      color="muted"
      onClick={toggleColorMode}
      icon={<SwitchIcon />}
      aria-label={`Switch to ${text} mode`}
      title={`Switch to ${text} mode`}
      _hover={{ color: "fg", bg: "accentSoft" }}
      _active={{ bg: "accentSoft" }}
      {...props}
    />
  );
};
